module.exports = function() {
  return new Worker(__webpack_public_path__ + "756836f5cc3de096f9d3.worker.js");
};